import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import Spinner from '@cloudscape-design/components/spinner';

const LoginPage = lazy(() => import('../pages/LoginPage'));
const RegisterPage = lazy(() => import('../pages/RegisterPage'));
const AccountPage = lazy(() => import('../pages/AccountPage'));
const HomePage = lazy(() => import('../pages/HomePage'));
const SearchPage = lazy(() => import('../pages/SearchPage'));
const IncidentDetailPage = lazy(() => import('../pages/IncidentDetailPage'));
const LandingPlannerPage = lazy(() => import('../pages/LandingPlannerPage'));
const AircraftCatalogPage = lazy(() => import('../pages/AircraftCatalogPage'));
const SimulatorPage = lazy(() => import('../pages/SimulatorPage'));
const ComingSoonPage = lazy(() => import('../pages/ComingSoonPage'));
const AdminDashboardPage = lazy(() => import('../pages/AdminDashboardPage'));
const SimControlPage = lazy(() => import('../pages/SimControlPage'));
const SimSessionsPage = lazy(() => import('../pages/SimSessionsPage'));
const SimSessionDetailPage = lazy(() => import('../pages/SimSessionDetailPage'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<Spinner size="large" />}>{children}</Suspense>
);

/** Public routes (no auth required) */
export const publicRoutes: RouteObject[] = [
  {
    path: '/login',
    element: (
      <SuspenseWrapper>
        <LoginPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: '/register',
    element: (
      <SuspenseWrapper>
        <RegisterPage />
      </SuspenseWrapper>
    ),
  },
];

/** Protected routes (auth required) */
export const protectedRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <SuspenseWrapper>
        <HomePage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'incidents',
    element: (
      <SuspenseWrapper>
        <SearchPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'incidents/:ntsbNumber',
    element: (
      <SuspenseWrapper>
        <IncidentDetailPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'landing-planner',
    element: (
      <SuspenseWrapper>
        <LandingPlannerPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'aircraft',
    element: (
      <SuspenseWrapper>
        <AircraftCatalogPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'landing-planner/simulator',
    element: (
      <SuspenseWrapper>
        <SimulatorPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'instructor-marketplace',
    element: (
      <SuspenseWrapper>
        <ComingSoonPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'admin',
    element: (
      <SuspenseWrapper>
        <AdminDashboardPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'account',
    element: (
      <SuspenseWrapper>
        <AccountPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'sim-control',
    element: (
      <SuspenseWrapper>
        <SimControlPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'sim-control/sessions',
    element: (
      <SuspenseWrapper>
        <SimSessionsPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'sim-control/sessions/:sessionId',
    element: (
      <SuspenseWrapper>
        <SimSessionDetailPage />
      </SuspenseWrapper>
    ),
  },
];
